export enum AlertRuleConditionType {
  NEW_ISSUE_CREATED = 'NEW_ISSUE_CREATED',
  ISSUE_MARKED_AS_UNRESOLVED = 'ISSUE_MARKED_AS_UNRESOLVED',
  ISSUE_UNARCHIVED = 'ISSUE_UNARCHIVED',
  EXISTING_ISSUE_SEVERITY_MARKED_AS_HIGH = 'EXISTING_ISSUE_SEVERITY_MARKED_AS_HIGH',
  NEW_ISSUE_SEVERITY_MARKED_AS_HIGH = 'NEW_ISSUE_SEVERITY_MARKED_AS_HIGH',
  NUMBER_OF_SPANS_IN_ISSUE_GREATER_THAN = 'NUMBER_OF_SPANS_IN_ISSUE_GREATER_THAN',
  NUMBER_OF_AFFECTED_END_USERS_IN_ISSUE_GREATER_THAN = 'NUMBER_OF_AFFECTED_END_USERS_IN_ISSUE_GREATER_THAN',

  SESSION_RECORDING_CREATED = 'SESSION_RECORDING_CREATED',

  DEBUGGING_AGENT_FIX_PUSHED = 'DEBUGGING_AGENT_FIX_PUSHED',
}
